import React from 'react';

import { Text } from '@rtkwlf/c3-core-react';
import {
  TimelineItem,
  TimelineItemContent,
  TimelineItemTrigger,
} from '@rtkwlf/c3-recipes-timeline';
import type { Blueprint } from '@rtkwlf/track-public';
import { useQuery } from '@tanstack/react-query';

import { useGetOrganizationOptions } from '@apis/track-public/query-options';

import { ConciergeTierBadge } from '../../../../../components/concierge-tier-badge/concierge-tier-badge';
import { useSecurityJourneyTranslations } from '../../../../../locales/use-security-journey-translations';

import styles from './security-focus-timeline-blueprint.module.css';

type SecurityFocusTimelineBlueprintProps = {
  name: Blueprint['name'];
  tier: Blueprint['tier'];
};

const SecurityFocusTimelineBlueprint = ({
  name,
  tier,
}: SecurityFocusTimelineBlueprintProps) => {
  /**
   * Get an instance of translations
   */
  const { t } = useSecurityJourneyTranslations();

  const { data: organization } = useQuery(useGetOrganizationOptions());

  const isOrganizationTierNonLegacy = React.useMemo(() => {
    return organization?.tierInfo && organization.tierInfo.legacy === false;
  }, [organization]);

  return (
    <TimelineItem>
      <TimelineItemTrigger
        label={name}
        color="light-grey"
        variant="secondary"
      />
      <TimelineItemContent
        className={styles['sft-blueprint-item-content']}
        data-testid="security-focus-timeline-item-blueprint"
      >
        <header className={styles['sft-blueprint-item-header']}>
          <Text as="div" size="3" weight="bold">
            {name}
          </Text>
        </header>
        <div className={styles['sft-blueprint-item-content-details']}>
          {isOrganizationTierNonLegacy && (
            <div className={styles['sft-blueprint-item-tier']}>
              <Text size="2" weight="bold">
                {t('focusID.timeline.tier')}
              </Text>
              <ConciergeTierBadge.Spidr tier={tier} />
            </div>
          )}
        </div>
      </TimelineItemContent>
    </TimelineItem>
  );
};

export { SecurityFocusTimelineBlueprint };
export type { SecurityFocusTimelineBlueprintProps };
